
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import JobPage from '../pages/job/page';
import StudyPage from '../pages/study/page';
import ImmigrationPage from '../pages/immigration/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/job',
    element: <JobPage />,
  },
  {
    path: '/study',
    element: <StudyPage />,
  },
  {
    path: '/immigration',
    element: <ImmigrationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
